module.exports = __webpack_public_path__ + "images/home/product/mobile/features-kanban-1a476567e8db121389902ff63fb41577.png";